module.exports = __webpack_public_path__ + "media/images/turismoCentroPT-9e16dcd08cfd74f2cf2c2b8c7c735831.jpeg";